function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgInformationenAvacon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 50 50",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(11.1995,0,0,10.9018,-4.49509,-3.11587)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.401,
    y: 0.286,
    width: 4.464,
    height: 4.586,
    style: {
      fill: "rgb(0,85,100)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "informationen_avacon"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.876112,0,0,0.876112,4.89369,5.22203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.627,38.766L6.344,38.766L6.344,6.335L38.776,6.335L38.776,34.498",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: "1.95px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "informationen_avacon1",
    serifid: "informationen_avacon",
    transform: "matrix(0.876112,0,0,0.876112,5.2889,5.22203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.789,16.199C20.789,15.057 21.517,14.557 22.476,14.557C23.32,14.557 24.117,15.057 24.117,16.199C24.117,17.362 23.321,17.796 22.476,17.796C21.516,17.796 20.789,17.361 20.789,16.199ZM21.13,19.757L23.891,19.757L23.891,30.159L21.13,30.159L21.13,19.757Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInformationenAvacon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/informationen_avacon.94a7b22b.svg";
export { ForwardRef as ReactComponent };